import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './CardText.css';

const propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const defaultProps = {
  className: undefined,
  tag: 'p',
};

const CardText = ({ className, tag: Tag, ...other }) => {
  const classes = classNames(className, 'apollo-card-text');
  return <Tag {...other} className={classes} />;
};

CardText.propTypes = propTypes;
CardText.defaultProps = defaultProps;

export default CardText;
